import Vue from 'vue';
import _ from 'lodash';
import {
    GET_OPERATORS_LIST_REQUEST,
    GET_OPERATORS_LIST_SUCCESS,
    GET_OPERATORS_LIST_FAILURE,
    UPDATE_OPERATORS_LIST_PARAMS,
    RESET_OPERATORS_LIST,
    RESOLVE_OPERATORS_LIST_PARAMS,
    REMOVE_BIND_REQUEST,
    REMOVE_BIND_SUCCESS,
    REMOVE_BIND_FAILURE,
    RESOLVE_REMOVE_BIND_PARAMS
} from '../mutationTypes';

const state = {
    loading: false,
    page: 1,
    pageSize: 20,
    totalCount: 0,
    startEndDate: [], // 组件返回形式为数组, 请求时分开提交
    listData: [],
    pageCount: 1,
    searchKey: 1, // 搜索类型:1账号名称, 2真实姓名, 3手机号
    searchVal: '', // 搜索值
    password: '', // 登录密码
    reqParams: {},
    reomveBindReqParams: {}
};

const mutations = {
    [GET_OPERATORS_LIST_REQUEST](state) {
        state.loading = true;
    },
    [GET_OPERATORS_LIST_SUCCESS](state, res) {
        state.loading = false;

        state.pageCount = res.page_count;
        state.listData = res.data;
        state.totalCount = res.count;
    },
    [GET_OPERATORS_LIST_FAILURE](state) {
        state.loading = false;

        state.pageCount = 1;
        state.listData = [];
    },
    // 更新请求参数
    [UPDATE_OPERATORS_LIST_PARAMS](state, params) {
        const {
            searchKey, searchVal, startEndDate, page, password
        } = params;

        if (searchKey || searchKey === '') state.searchKey = searchKey;
        if (searchVal || searchVal === '') state.searchVal = searchVal;
        if (password || password === '') state.password = password;

        if (startEndDate) {
            state.startEndDate = startEndDate;
        }

        if (page) {
            state.page = page;
            state.reqParams.page = page; // 分页要进行请求
        }
    },
    [RESET_OPERATORS_LIST](state) {
        _.extend(state, _.cloneDeep({
            loading: false,
            page: 1,
            pageSize: 20,
            startEndDate: [],
            listData: [],
            pageCount: 1,
            searchKey: 1,
            searchVal: '',
            reqParams: {},
        }));
    },
    [RESOLVE_OPERATORS_LIST_PARAMS](state, reqParams) {
        state.reqParams = reqParams;
    },
    [REMOVE_BIND_REQUEST](state) {
        state.loading = true;
    },
    [REMOVE_BIND_SUCCESS](state, idIndex) {
        state.loading = false;

        state.listData.splice(idIndex, 1);
        state.password = '';
    },
    [REMOVE_BIND_FAILURE](state) {
        state.loading = false;
    },
    [RESOLVE_REMOVE_BIND_PARAMS](state, reqParams) {
        state.reomveBindReqParams = reqParams;
    },
};

export const actions = {
    async getOperatorsList({ commit }) {
        commit(GET_OPERATORS_LIST_REQUEST);
        const res = await Vue.$ajax.get('workersList', state.reqParams);

        if (!res.errorType) {
            commit(GET_OPERATORS_LIST_SUCCESS, res);
        } else {
            commit(GET_OPERATORS_LIST_FAILURE);
        }
    },
    resolveOperatorsListParams({ commit }) {
        let params = _.pick(state, ['page']);
        params = Object.assign({}, params, {
            start_date: state.startEndDate.length ? state.startEndDate[0] : null,
            end_date: state.startEndDate.length ? state.startEndDate[1] : null
        });
        params.search_key = state.searchKey;
        params.search_val = state.searchVal;
        params.search_key = state.searchKey;
        params.pagesize = state.pageSize;

        commit(RESOLVE_OPERATORS_LIST_PARAMS, params);
    },
    resetOperatorsList({ commit }) {
        commit(RESET_OPERATORS_LIST);
    },
    async removeBind({ commit }, idIndex) {
        commit(REMOVE_BIND_REQUEST);

        const res = await Vue.$ajax.get('workersAction', state.reomveBindReqParams);
        if (!res.errorType) {
            commit(REMOVE_BIND_SUCCESS, idIndex);
            return res;
        }
        commit(REMOVE_BIND_FAILURE);
        return res;
    },
    resolveRemoveBindParams({ commit }, id) {
        const params = _.pick(state, ['password']);
        params.id = id;
        commit(RESOLVE_REMOVE_BIND_PARAMS, params);
    },
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/operators.js